import { connect } from 'react-redux';
import CateringDashboard from './CateringDashboard';
import { getCateringDashboardSummary } from './cateringDashboardActions';

const mapStateToProps = (state) => ({
    summary: state.cateringDashboard.summary,
    isLoading: state.cateringDashboard.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
    getCateringDashboardSummary: (payload) => dispatch(getCateringDashboardSummary(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CateringDashboard);
